import { useParams } from "react-router-dom";
import {
  DossierEmployeeDetailsBody,
  DossierEmployeeDetailsHeader,
} from "./components";
import { useEmployeeDetailsWithRefetch } from "@hooks/HRM/employee/useEmployee";
import { GetEmployeeDetails } from "@utils/getEmployeeDetails";

const DossierEmployeeDetails = () => {
  const { id } = useParams();

  const { employeeInfo } = useEmployeeDetailsWithRefetch(id);
  const { employeeName, employeeImage, employeePosition } =
    GetEmployeeDetails(employeeInfo);

  return (
    <div className="d-flex flex-column gap-10 p-10">
      <DossierEmployeeDetailsHeader
        employeeName={employeeName}
        employeeImage={employeeImage}
        employeePosition={employeePosition}
      />
      <DossierEmployeeDetailsBody employeeId={id} employeeName={employeeName} />
    </div>
  );
};

export default DossierEmployeeDetails;
